import React, { useEffect, useState } from "react";
import axios from "axios";

const OfferSec = () => {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/discount/get-all-discount`
        );

        const data = response.data?.data || response.data || [];

        // Sort banners by displayOrder
        const sorted = data.sort((a, b) => a.displayOrder - b.displayOrder);

        setBanners(sorted);
      } catch (error) {
        console.error("Failed to load banners", error);
      }
    };

    fetchBanners();
  }, []);

  const bigBanners = banners.filter((b) => b.bannerType === "big");
  const smallBanners = banners.filter((b) => b.bannerType === "small");

  // REUSABLE CARD
  const BannerCard = ({ item, height }) => {
    const hasImage =
      item.backgroundImage && item.backgroundImage.trim() !== "";

    return (
      <div
        className="relative w-full rounded-xl shadow-md overflow-hidden"
        style={{
          height: height,
          backgroundColor: !hasImage ? item.color : "transparent",
        }}
      >
        {/* SHOW IMAGE IF EXISTS */}
        {hasImage && (
          <img
            src={item.backgroundImage}
            alt={item.title}
            className="w-full h-full object-cover"
          />
        )}

        {/* TEXT OVERLAY ALWAYS ON TOP */}
        <div
          className="absolute top-1/2 left-1/2 z-10 p-3 text-white 
             -translate-x-1/2 -translate-y-1/2 text-center"
        >
          {/* <h3 className="text-2xl font-bold font-philosopher">{item.title}</h3> */}
          {/* <p className="text-lg font-poppins">{item.discountText}</p> */}
        </div>

      </div>
    );
  };

  return (
    <div className="w-full bg-white flex flex-col md:flex-row justify-center items-stretch gap-6 px-4 md:px-10 pb-10">

      {/* Big Banner 1 */}
      <div className="flex justify-center items-center w-full md:w-1/4">
        {bigBanners[0] && <BannerCard item={bigBanners[0]} height="500px" />}
      </div>

      {/* First 2 Small Banners */}
      <div className="flex flex-col justify-between gap-6 w-full md:w-1/4">
        {smallBanners.slice(0, 2).map((item) => (
          <BannerCard key={item._id} item={item} height="240px" />
        ))}
      </div>

      {/* Big Banner 2 */}
      <div className="flex justify-center items-center w-full md:w-1/4">
        {bigBanners[1] && <BannerCard item={bigBanners[1]} height="500px" />}
      </div>

      {/* Next 2 Small Banners */}
      <div className="flex flex-col justify-between gap-6 w-full md:w-1/4">
        {smallBanners.slice(2, 4).map((item) => (
          <BannerCard key={item._id} item={item} height="240px" />
        ))}
      </div>
    </div>
  );
};

export default OfferSec;
